import React from 'react'
import CosmicNebulaMastercard from './cursor-wander-card'

interface GiftCardProps {
  className?: string
}

const GiftCard: React.FC<GiftCardProps> = ({ className = "" }) => {
  return (
    <div className={`flex justify-center ${className}`}>
      <CosmicNebulaMastercard
        cardholderName="$100 GIFT CARD"
        theme={{
          primaryColor: "#9B775D", // Hudson brand color
          secondaryColor: "#083B3A", // Hudson dark teal
          glowColor: "rgba(155, 119, 93, 0.9)", // Hudson glow
        }}
        logoText={{
          topText: "HUDSON",
          bottomText: "MY HOME"
        }}
        height="320px"
        width="500px"
      />
    </div>
  )
}

export default GiftCard
